const SEARCH_EMAIL_REGEX = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
const SEARCH_FRENCH_PHONE_REGEX = /^(?:0\d{9}|\+33\d{9})$/;
const SEARCH_NAME_REGEX =
  /^[A-Za-zÀ-ÖØ-öø-ÿ]{2,}(?:[ '-][A-Za-zÀ-ÖØ-öø-ÿ]{2,})*$/;

function normalizeFrenchPhoneCandidate(value: string): string {
  return value.trim().replace(/[\s.-]/g, "");
}

export {
  normalizeFrenchPhoneCandidate,
  SEARCH_EMAIL_REGEX,
  SEARCH_FRENCH_PHONE_REGEX,
  SEARCH_NAME_REGEX,
};
